import axios from '../base'
import {
  FavoriteFacility,
  FavoriteMutationResponse,
  FavoritesResponse,
} from './favorite.types'

export class FavoriteService {
  list = async (userId: number): Promise<FavoriteFacility[]> => {
    try {
      const { data } = await axios.get<FavoritesResponse>(
        `/users/${userId}/favorites`
      )
      // The backend uses `error` for both auth issues and logical errors.
      // Only trust an explicit list back; otherwise return empty.
      if (Array.isArray(data?.data)) return data.data
      return []
    } catch {
      return []
    }
  }

  // Mutations rely on HTTP status for success — endpoints are idempotent
  // (200 even on duplicate). The slice's rejection handler reverts state
  // and refetches. Body `error` field varies (string vs boolean) and is
  // not reliable.
  add = async (
    userId: number,
    locationId: number
  ): Promise<FavoriteMutationResponse> => {
    const { data } = await axios.post<FavoriteMutationResponse>(
      `/users/${userId}/favorites`,
      { location_id: locationId }
    )
    return data ?? {}
  }

  remove = async (
    userId: number,
    locationId: number
  ): Promise<FavoriteMutationResponse> => {
    const { data } = await axios.delete<FavoriteMutationResponse>(
      `/users/${userId}/favorites/${locationId}`
    )
    return data ?? {}
  }
}

export default new FavoriteService()
